import { Container, Graphics, Text } from 'pixi.js';

export interface ButtonOptions {
  readonly label: string;
  readonly width: number;
  readonly height?: number;
  readonly color?: number;
  readonly onTap: () => void;
}

/** Простая кнопка тестового меню: мышь, касание, подсветка при наведении. */
export class Button extends Container {
  private readonly text: Text;

  constructor(options: ButtonOptions) {
    super();
    const height = options.height ?? 52;
    const color = options.color ?? 0x1b5d74;
    const bg = new Graphics();
    const draw = (hover: boolean): void => {
      bg.clear()
        .roundRect(0, 0, options.width, height, 14)
        .fill(hover ? 0x2a86a3 : color)
        .stroke({ width: 3, color: 0x9edcf0, alpha: hover ? 0.9 : 0.45 });
    };
    draw(false);
    const text = (this.text = new Text({
      text: options.label,
      style: {
        fill: 0xf2fbff,
        fontFamily: 'system-ui, sans-serif',
        fontSize: 19,
        fontWeight: '700',
      },
    }));
    text.anchor.set(0.5);
    text.position.set(options.width / 2, height / 2);
    this.addChild(bg, text);

    this.eventMode = 'static';
    this.cursor = 'pointer';
    this.on('pointerover', () => draw(true));
    this.on('pointerout', () => draw(false));
    this.on('pointertap', options.onTap);
  }

  setLabel(label: string): void {
    this.text.text = label;
  }
}
